import colors from "theme/colors";

const DOT_SIZE = 10;

const styles = {
  bellOverlay: {
    position: "absolute",
    right: 2,
    top: 3,
    width: DOT_SIZE,
    height: DOT_SIZE,
    borderRadius: DOT_SIZE / 2,
    backgroundColor: colors.error.rose,
    borderWidth: 1,
    borderColor: colors.neutral.cotton,
  },
};

export default styles;
